<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <iq-card>
          <template v-slot:headerTitle>
            <h1 class="card-title text-left pt-2">Import</h1>
          </template>
          <template v-slot:body>
            <div class="about-info m-0 p-0">
              <b-row>
                <b-col cols="3">Delimiter</b-col>
                <b-col cols="9">
                  <b-link>{{ dataImport.delimiter }}</b-link>
                </b-col>
                <b-col cols="3">List name:</b-col>
                <b-col cols="9">
                  <b-link>{{ dataImport.list_name }}</b-link>
                </b-col>
                <b-col cols="3">Progress:</b-col>
                <b-col cols="9">
                  <b-link>{{ dataImport.progress * 100 }} %</b-link>
                </b-col>
                <b-col cols="3">Import error:</b-col>
                <b-col cols="9">{{ dataImport.error || "-" }}</b-col>
                <b-col cols="3">Number of imported:</b-col>
                <b-col cols="9">
                  <b-link>{{ dataImport.number_of_imported }}</b-link>
                </b-col>
                <b-col cols="3">Number of error lines:</b-col>
                <b-col cols="9">
                  <b-link>{{ dataImport.number_of_errors }}</b-link>
                </b-col>
                <b-col cols="3">Created:</b-col>
                <b-col cols="9">{{ dataImport.created_at | formatDate }}</b-col>
              </b-row>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-row v-if="logLines">
      <b-col>
        <iq-card>
          <template v-slot:headerTitle>
            <h1 class="card-title text-left pt-2">Log</h1>
          </template>
          <template v-slot:body>
            <div class="about-info m-0 p-0">
              <b-row v-for="(logLine, idx) in logLines" :key="idx">
                <b-col>{{ logLine }}</b-col>
              </b-row>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from "../../config/pluginInit";
import IqCard from "../../components/core/cards/iq-card.vue";

import gql from "graphql-tag";
const GET_DATA_IMPORT = gql`
  query getDataImport($id: uuid!) {
    data_imports_by_pk(id: $id) {
      id
      delimiter
      list_name
      created_at
      log
      progress
      number_of_imported
      number_of_errors
      error
    }
  }
`;

export default {
  name: "ImportsDetail",
  components: {
    IqCard
  },
  mounted() {
    core.index();
    setTimeout(() => {
      this.$apollo.queries.dataImport.refetch();
    }, 3000);
  },
  data() {
    return {
      dataImport: {}
    };
  },
  apollo: {
    dataImport() {
      return {
        query: GET_DATA_IMPORT,
        variables: {
          id: this.$route.params.id
        },
        update: data => data.data_imports_by_pk
      };
    }
  },
  computed: {
    logLines() {
      if (this?.dataImport?.log?.lines) {
        return this.dataImport.log.lines;
      } else {
        return [];
      }
    }
  }
};
</script>
